<div class="container-dialog">
    <div [class]="'status '+(data.severity?data.severity:'info')"></div>
    <div class="contenido">
        <div class="header">
            <div class="title">
                {{data.title}}
            </div>
            <button (click)="dialogRef.close()" class="close-button">
                <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
            </button>
        </div>
        <div class="cuerpo"> {{data.message}} </div>
        <div class="footer">
            <button (click)="dialogRef.close()" mat-raised-button color="primary">
                <span class="refresh-text"> Cerrar</span>
            </button>
        </div>
    </div>
</div>